import type { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import { ReportTags } from "./ReportTags";
import type { ReportListResponseDto } from "@/api/dtos";
import type { ReportFile } from "./_models/Report";
import { toReportFileFromDto } from "./_transformers/toReportFileFromDto";

/** The inventory report files on the eStore SFTP, newest first. */
export const getInventoryReportListApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getInventoryReportList: builder.query<ReportFile[], void>({
      queryFn: async () => {
        try {
          const res = await axios.get<ReportListResponseDto>(
            `${backendBase()}/inventory-reports`,
            { headers: { Accept: "application/json" } },
          );
          const files = res.data.files
            .map((x) => toReportFileFromDto(x))
            .sort((a, b) => b.modified.localeCompare(a.modified));
          return { data: files };
        }
        catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            return {
              error: { status: e.response.status, data: e.response.data } as FetchBaseQueryError,
            };
          }
          return {
            error: { status: "FETCH_ERROR", error: String(e) } as FetchBaseQueryError,
          };
        }
      },
      providesTags: [{ type: ReportTags.InventoryReport, id: "LIST" }],
    }),
  }),
});

export const getInventoryReportList = getInventoryReportListApi.endpoints.getInventoryReportList;
